import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditMrfType from "./EditMrfType";
import { getMrfTypeDropdownData,editMrfType,getMrfTypeList } from "services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
  dropdownData: state.MaterialRequistionForm.dropdownData,
  mrfTypeData: state.MaterialRequistionForm.mrfTypeData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMrfTypeDropdownData,
      editMrfType,
      getMrfTypeList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditMrfType);